module.exports = __webpack_public_path__ + "static/media/story_02.14ebe6af.jpg";